import { render, staticRenderFns } from "./PageSubNav.vue?vue&type=template&id=6904a5fa&scoped=true&"
import script from "./PageSubNav.vue?vue&type=script&lang=js&"
export * from "./PageSubNav.vue?vue&type=script&lang=js&"
import style0 from "./PageSubNav.vue?vue&type=style&index=0&id=6904a5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904a5fa",
  null
  
)

export default component.exports